import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Link from '../../common/Link'
import { trackEventLog } from '../../../core/utils'

class Pop extends React.Component {

  static propTypes = {
    data: PropTypes.object.isRequired,
    closePop: PropTypes.func.isRequired,
  }

  render() {
    const { data, closePop } = this.props
    return (
      <div>
        <div className={s.cover} />
        <div className={s.content}>
          <Link
            to={data.url}
            extraParams={{
              inLoc: 'web_home_popup',
              Pdt: 'jpkWeb',
            }}
            onClick={() => { trackEventLog('w/index/popup') }}
          >
            <img src={data.img} alt={data.url} />
          </Link>
          <span role={'button'} className={s.close} onClick={() => closePop(data.url)} />
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Pop);



// WEBPACK FOOTER //
// ./src/components/p_home/Pop/index.js